import gql from 'graphql-tag';
import { postAndCommentsFragment } from '../fragments/post-and-comments.fragment';

export const getPostWithCommentsQuery = gql`
  query getPostWithComment(
    $postID: ID!
    $commentLimit: Int
    $afterComment: ID
  ) {
    post(postID: $postID) {
      ...postAndCommentsFragment
    }
  }
  ${postAndCommentsFragment}
`;
